<template>
  <div id="tourists-selector">
    <div class="box box-dropdown box--tourists-selector">
      <div class="box-content">
        <tourists-quantity-group
            :value="localTourists.adults"
            label="Взрослые"
            :min="1"
            @change="on_change_adults"
        />

        <tourists-kids
            :kids="localTourists.kids"
            :min_age="min_age"
            @change="on_change_kids"
        />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import TouristsQuantityGroup from "./TouristsQuantityGroup";
  import TouristsKids from "./TouristsKids";
  export default {
    components: {TouristsQuantityGroup, TouristsKids},
    props: ['tourists', 'min_age'],
    data(){
      return {
        localTourists: this.tourists,
        // adults: this.tourists === undefined ? 2 : this.tourists.adults,
        // kids: this.tourists === undefined ? [] : this.tourists.kids,
      }
    },
    methods: {
      on_change_adults(v){
        // console.log('TouristsSelector::on_change_adults', v)
        this.$set(this.localTourists,'adults',v);
        this.$emit('change', this.localTourists)
      },
      on_change_kids(k){
        // console.log('TouristsSelector::on_change_kids', k)
        this.$set(this.localTourists,'kids',k);
        this.$emit('change', this.localTourists)
      },
    }

  }
</script>
<style>
  #tourists-selector {
    position: absolute;
    /*top: 2px;*/
  }
</style>